/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState } from "react";
import { getShopUrl, AddStoreConfig, getStoreConfig } from '../Services/CommonServices';
import { environment } from '../Services/environment';
import { ToastMarkup } from '../common/ToastMarkup';
import { validateTagSeparator } from '../Validation/regex';
const endpoint = environment.serverUrl;

export default function SettingsConfig({activate,onCloseSettingsModal,setTagsSeparator}) {
    var storeUrl = getShopUrl();
    const [settingsModalActive, setSettingsModalActive] = useState(false);
    const handleSettingsChangeModal = useCallback(() => { setSettingsModalActive(!settingsModalActive) }, [settingsModalActive]);
    const [configLoading, setConfigLoading] = useState(false);
    const [checkedExportFormat, setCheckedExportFormat] = useState(0);
    const closeSettingsModal = () => {
        setSettingsModalActive(false);
        onCloseSettingsModal();
      };
    const [toast, setToast] = useState(false);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);

    const handleChangeTagSeparatorPrice = useCallback((newValue) => { if (ValidateTagSeparator(newValue)) { setTagSeparator(newValue); setTagSeparatorValid(true) } else { setTagSeparatorValid(false)} }, []);
    const [tagSeparator, setTagSeparator] = useState(null);
    const [tagSeparatorValid, setTagSeparatorValid] = useState(true);
    useEffect(() => {
        getConfig();
        setSettingsModalActive(activate);
    }, [activate]);

    const settingsModal = (
        <s-modal
            open={settingsModalActive}
            onClose={closeSettingsModal}
            heading="Settings"
        >
            <s-box padding="base">
                <s-stack gap="base">
                    <s-box>
                        <s-text-field
                            label="Tag Separator"
                            type="text"
                            value={tagSeparator}
                            onChange={(e) => handleChangeTagSeparatorPrice(e.target.value)}
                            error={tagSeparatorValid ? undefined : "Only special characters are allowed."}
                            helpText="Separate tags to individual columns. Example: '-' or '_'"
                        />
                    </s-box>
                    <s-box>
                        <s-stack gap="small">
                            <s-heading>Export format</s-heading>
                            <s-radio-button
                                label="CSV"
                                checked={checkedExportFormat === 0}
                                onChange={() => setCheckedExportFormat(0)}
                            />
                            <s-radio-button
                                label="XLSX"
                                checked={checkedExportFormat === 1}
                                onChange={() => setCheckedExportFormat(1)}
                            />
                        </s-stack>
                    </s-box>
                </s-stack>
            </s-box>
            <s-button slot="primary-action" loading={configLoading} onClick={addConfig}>
                Save
            </s-button>
            <s-button slot="secondary-actions" onClick={handleSettingsChangeModal}>
                Cancel
            </s-button>
        </s-modal>
    );
    return (
        <>
            {settingsModal}
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} error={false} />
        </>
    );

    function addConfig() {
        setConfigLoading(true);
        setToast(false);
        var config = {
            tagSeparator: tagSeparator,
            exportFormat: checkedExportFormat
        }
        AddStoreConfig(config, storeUrl).then(function (result) {
            setConfigLoading(false);
            setToast(true);
            setSettingsModalActive(false);
            setTagsSeparator(tagSeparator);
            onCloseSettingsModal();
        });
    }

    function getConfig() {
        getStoreConfig(storeUrl).then(function (result) {
            if (result !== null) {
                setTagSeparator(result?.tagSeparator);
                setCheckedExportFormat(result?.exportFormat);
            }
        });
    }

    function ValidateTagSeparator(tag) {
        if (validateTagSeparator.test(tag)) {
            return true;
        }
        else {
            return false;
        }

    }
}
